import merge from 'lodash/merge';

import { token } from '@atlaskit/tokens';
import { GET_EXTRA_SELECT_PROPS } from '@atlassian/eoc-schedule-common';

// SEE: https://atlaskit.atlassian.com/packages/design-system/select/example/select-in-modal-dialog
export const getExtraSelectProps = () =>
	merge(GET_EXTRA_SELECT_PROPS(), {
		styles: {
			container: (base: any) => ({
				...base,
				flex: `1 1 auto`,
				marginLeft: `${token('space.negative.075', '-6px')}`,
			}),
		},
	});
